import { createRouter, createWebHistory } from 'vue-router'


//Import Company Routes 
import adminUserRoute from './adminUserRoute.js'
import companyUserRoute from './companyUsersRoute.js'
import i18n from '@/Lang/lang.js'
//Merge all the route
const finalRoute = adminUserRoute.concat(companyUserRoute);

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes:finalRoute,
    linkActiveClass: 'active',
    linkExactActiveClass: "active"
})

router.beforeEach((to, from, next) => {
    var mainTitle = localStorage.getItem('companyName');
    if (mainTitle == null || mainTitle == '')
        mainTitle = 'Welcome';
    if (to.name == 'undefinded' || typeof to.name == "undefined") {
        to.name = 'login'

    }
    let storedData = JSON.parse(localStorage.getItem('moduleList'));
    
    if (storedData != null && storedData.length != 0) {
        let moduleFound = storedData.find(module => module.moduleCode === "2312");
        let loginUserId = localStorage.getItem('userId')
        // If module is found, display it or use it
        if (loginUserId != null && loginUserId != "") {
            if (moduleFound) {
                //window.location.href = "/dashboard";
            } else {
                // If module is not found, show a message
                //window.location.href = "/BookingListing";
                if (to.path == '/dashboard') {
                    if ((localStorage.getItem('themeName') == 'GolfCart' || localStorage.getItem('themeName') == 'Restaurant' || localStorage.getItem('themeName') == 'SpaServices') && localStorage.getItem('userType') == 'usertype05') {
                        debugger
                        window.location.href = "/CustomerBookingListing";
                    }
                    else if (localStorage.getItem('themeName') == 'ExperienceTheme' && localStorage.getItem('userType') == 'usertype07') {
               
                        window.location.href = "/ExperienceBooking";
                    }
                    else {
                        window.location.href = "/BookingListing";
                    }
                   
                    //next();
                }
            }
        }
    }
    document.title = `${mainTitle} | ` + (i18n.global.t(`routesName.${to.name}`));
    window.scrollTo(0, 0);
    next();
})

export default router
